import { resolve } from 'library/helpers/path-resolver';
import DataQuery from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const userOutcomesQuery = async (uuid, includeArchived = true) => {
  const params = uuid ? { uuid: uuid } : {};
  const outcomeParams = jsonToInputParams({
    include_archived: includeArchived,
  });
  return await DataQuery(
    `
    {
      user(${jsonToInputParams(params)}) {
        id
        uuid,
        outcomes(${outcomeParams}) {
          id
          name
          description
          color
          archived:archived_at
          updated_at
          created_at
          goals {
            id
            name
            completed_at
            icon {
              id
              category
              action
              filename
            }
            steps {
              id
              name
              complete
              step_completion_actions {
                id
                outcome_id
                action_type
                step {
                  id
                  goal_id
                }
              }
              step_resources {
                id
                step_id
                resource_type
                name
                link
                title
                service_provider_categories {
                  id
                  name
                }
              }
              step_questions {
                id
                question {
                  id
                  user_response {
                    answered
                    string_response
                    selected_answer_choices {
                      id
                      key
                      value
                    }
                  }
                }
              }
              completion_method
              description
            }
          }
        }
      }
    }

  `
  );
};

const userOutcomesParseQuery = (data) => ({
  outcomes: resolve(data, 'user/outcomes', []),
});

export { userOutcomesQuery, userOutcomesParseQuery };
